export default "__VITE_ASSET__CHQaKCX4__"